var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTodayOrderLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 46 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 686"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 186",
    d: "M36 0A36 36 0 1 1 0 36 36 36 0 0 1 36 0z",
    style: {
      fill: "#f3f1ff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 416",
    d: "M15 26H1.111A1.1 1.1 0 0 1 0 24.917v-19.5a1.1 1.1 0 0 1 1.111-1.083h3.333V1.083A1.1 1.1 0 0 1 5.555 0h7.778a1.131 1.131 0 0 1 .785.318l5.556 5.417A1.079 1.079 0 0 1 20 6.5v14.083a1.1 1.1 0 0 1-1.111 1.084h-2.777v3.25A1.1 1.1 0 0 1 15 26zM2.222 6.5v17.334H13.89v-2.167H5.555a1.1 1.1 0 0 1-1.111-1.084V6.5zm4.444-4.333V19.5h11.112V7.593h-4.445a1.1 1.1 0 0 1-1.111-1.084V2.167zM14.445 3.7v1.727h1.772z",
    transform: "translate(26 23)",
    style: {
      fill: "#876bfe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 417",
    d: "M.73 1.469h2.432a.735.735 0 0 0 0-1.469H.73a.735.735 0 0 0 0 1.469",
    transform: "translate(34.918 32.54)",
    style: {
      fill: "#876bfe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 418",
    d: "M5.595 0H.73a.735.735 0 0 0 0 1.469h4.865a.735.735 0 0 0 0-1.469",
    transform: "translate(35.217 35.811)",
    style: {
      fill: "#876bfe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 419",
    d: "M5.595 0H.73a.735.735 0 0 0 0 1.469h4.865a.735.735 0 0 0 0-1.469",
    transform: "translate(35.217 39.082)",
    style: {
      fill: "#876bfe"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodayOrderLogo);
export default __webpack_public_path__ + "static/media/today_order_logo.c91ac507c98ba3f4bd9952920f88635c.svg";
export { ForwardRef as ReactComponent };